export default {
    items: [{
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-dashboard',
            badge: {
                variant: 'primary',
                // text: 'NEW'
            }
        },
        {
            title: true,
            name: 'BLOG DETAILS',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Add a Blog',
            url: '/addablog',
            icon: 'icon-plus'
        },
        {
            name: 'Blog List',
            url: '/blogList',
            icon: 'fa fa-folder'
        },
        {
            title: true,
            name: 'TURTLE DETAILS',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },

        {
            name: 'Add a Turtle',
            url: '/addaturtle',
            icon: 'icon-plus'
        },
        {
            name: 'Turtle List',
            url: '/listturtles',
            icon: 'fa fa-globe',
            // badge: {
            //     variant: 'info',
            //     text: 'NEW'
            //   }
        },
        {
            title: true,
            name: 'USERS MANAGEMENT',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Add a User',
            url: '/addauser',
            icon: 'icon-user'
        },
        {
            name: 'Users List',
            url: '/userlist',
            icon: 'fa fa-folder'
        },
        {
            title: true,
            name: 'ADMIN MANAGEMENT',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Add an Admin',
            url: '/addanadmin',
            icon: 'fa fa-user-circle'
        },
        {
            name: 'Admins List',
            url: '/adminslist',
            icon: 'fa fa-suitcase'
        },
        {
            title: true,
            name: 'SIGHTINGS',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },

        {
            name: 'Sightings List',
            url: '/reportlist',
            icon: 'icon-list'
        },
        {
            name: 'Sightings Location',
            url: '/sightingsloc',
            icon: 'fa fa-map-marker'
        },
        {
            name: 'Observation',
            url: '/observation',
            icon: 'icon-eye'
        },
        {
            name: 'Rescue',
            url: '/rescue',
            icon: 'icon-star'
        },
        {
            title: true,
            name: 'Rescue Centers',
            url: '/rescue',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Add Rescue Center',
            url: '/addrescuecenter',
            icon: 'icon-plus'
        },
        {
            name: 'Centers Locations',
            url: '/rescuecntloc',
            icon: 'fa fa-map-marker'
        },
        {
            name: 'Rescue Centers',
            url: '/rescuecentersList',
            icon: 'icon-list'
        },

        // {
        //   title: true,
        //   name: 'REPORT GENERATION',
        //   class: '',
        //   wrapper: {
        //     element: '',
        //     attributes: {}
        //   }
        // },
        // {
        //   name: 'Donors List',
        //   url: '/users',
        //   icon: 'icon-puzzle'
        // },
        // {
        //   name: 'Report Generation',
        //   url: '/reportgeneration',
        //   icon: 'icon-star'
        // },
        // {
        //   name: 'Subscribers List',
        //   url: '/subscribers',
        //   icon: 'icon-cursor'
        // },
        // {
        //   title: true,
        //   name: 'Components',
        //   class: '',
        //   wrapper: {
        //     element: '',
        //     attributes: {}
        //   }
        // },
        // {
        //   name: 'Base',
        //   url: '/base',
        //   icon: 'icon-puzzle',
        //   children: [
        //     {
        //       name: 'Breadcrumbs',
        //       url: '/base/breadcrumbs',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Cards',
        //       url: '/base/cards',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Carousels',
        //       url: '/base/carousels',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Collapses',
        //       url: '/base/collapses',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Forms',
        //       url: '/base/forms',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Jumbotrons',
        //       url: '/base/jumbotrons',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'List Groups',
        //       url: '/base/list-groups',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Navs',
        //       url: '/base/navs',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Navbars',
        //       url: '/base/navbars',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Paginations',
        //       url: '/base/paginations',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Popovers',
        //       url: '/base/popovers',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Progress Bars',
        //       url: '/base/progress-bars',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Switches',
        //       url: '/base/switches',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Tables',
        //       url: '/base/tables',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Tabs',
        //       url: '/base/tabs',
        //       icon: 'icon-puzzle'
        //     },
        //     {
        //       name: 'Tooltips',
        //       url: '/base/tooltips',
        //       icon: 'icon-puzzle'
        //     }
        //   ]
        // },
        // {
        //   name: 'Buttons',
        //   url: '/buttons',
        //   icon: 'icon-cursor',
        //   children: [
        //     {
        //       name: 'Buttons',
        //       url: '/buttons/standard-buttons',
        //       icon: 'icon-cursor'
        //     },
        //     {
        //       name: 'Button Dropdowns',
        //       url: '/buttons/dropdowns',
        //       icon: 'icon-cursor'
        //     },
        //     {
        //       name: 'Button Groups',
        //       url: '/buttons/button-groups',
        //       icon: 'icon-cursor'
        //     },
        //     {
        //       name: 'Brand Buttons',
        //       url: '/buttons/brand-buttons',
        //       icon: 'icon-cursor'
        //     }
        //   ]
        // },
        // {
        //   name: 'Charts',
        //   url: '/charts',
        //   icon: 'icon-pie-chart'
        // },
        // {
        //   name: 'Icons',
        //   url: '/icons',
        //   icon: 'icon-star',
        //   children: [
        //     {
        //       name: 'CoreUI Icons',
        //       url: '/icons/coreui-icons',
        //       icon: 'icon-star',
        //       badge: {
        //         variant: 'info',
        //         text: 'NEW'
        //       }
        //     },
        //     {
        //       name: 'Flags',
        //       url: '/icons/flags',
        //       icon: 'icon-star'
        //     },
        //     {
        //       name: 'Font Awesome',
        //       url: '/icons/font-awesome',
        //       icon: 'icon-star',
        //       badge: {
        //         variant: 'secondary',
        //         text: '4.7'
        //       }
        //     },
        //     {
        //       name: 'Simple Line Icons',
        //       url: '/icons/simple-line-icons',
        //       icon: 'icon-star'
        //     }
        //   ]
        // },
        // {
        //   name: 'Notifications',
        //   url: '/notifications',
        //   icon: 'icon-bell',
        //   children: [
        //     {
        //       name: 'Alerts',
        //       url: '/notifications/alerts',
        //       icon: 'icon-bell'
        //     },
        //     {
        //       name: 'Badges',
        //       url: '/notifications/badges',
        //       icon: 'icon-bell'
        //     },
        //     {
        //       name: 'Modals',
        //       url: '/notifications/modals',
        //       icon: 'icon-bell'
        //     }
        //   ]
        // },
        // {
        //   name: 'Widgets',
        //   url: '/widgets',
        //   icon: 'icon-calculator',
        //   badge: {
        //     variant: 'primary',
        //     text: 'NEW'
        //   }
        // },
        // {
        //   divider: true
        // },
        // {
        //   title: true,
        //   name: 'Extras'
        // },
        // {
        //   name: 'Pages',
        //   url: '/pages',
        //   icon: 'icon-star',
        //   children: [
        //     {
        //       name: 'Login',
        //       url: '/pages/login',
        //       icon: 'icon-star'
        //     },
        //     {
        //       name: 'Register',
        //       url: '/pages/register',
        //       icon: 'icon-star'
        //     },
        //     {
        //       name: 'Error 404',
        //       url: '/pages/404',
        //       icon: 'icon-star'
        //     },
        //     {
        //       name: 'Error 500',
        //       url: '/pages/500',
        //       icon: 'icon-star'
        //     }
        //   ]
        // },
        // {
        //   name: 'Disabled',
        //   url: '/dashboard',
        //   icon: 'icon-ban',
        //   badge: {
        //     variant: 'secondary',
        //     text: 'NEW'
        //   },
        //   attributes: { disabled: true },
        // },
        // {
        //   name: 'Download CoreUI',
        //   url: 'http://coreui.io/vue/',
        //   icon: 'icon-cloud-download',
        //   class: 'mt-auto',
        //   variant: 'success',
        //   attributes: { target: '_blank', rel: 'noopener' }
        // },
        // {
        //   name: 'Try CoreUI PRO',
        //   url: 'http://coreui.io/pro/vue/',
        //   icon: 'icon-layers',
        //   variant: 'danger',
        //   attributes: { target: '_blank', rel: 'noopener' }
        // },
    ]
}